import { FC } from 'react';
import styled from 'styled-components';
import { variables } from '@splunk/themes';
import { Severity } from '@splunk/olly-react-ui/lib/SeverityIcon/types';
import { severityColorMap } from '@splunk/olly-react-ui/lib/SeverityIcon/SeverityColors';
import Bell from '@splunk/react-icons/Bell';
import { ThemeProvider, useLegacyThemeServiceKey } from '../../theme/ThemeProvider';

type BellProps = {
    variant: 'filled' | 'outlined';
    alertState: Severity;
};

const colorMap = { ...severityColorMap, Normal: variables.severityColorNormal };

const StyledBell = styled(Bell)<{ alertState: Severity }>`
    width: 20px;
    height: 20px;
    color: ${(props: { alertState: Severity }): any =>
        colorMap[props.alertState] || variables.contentColorDefault};
`;

export const BellIcon: FC<BellProps> = ({ variant, alertState }) => {
    const themeKey = useLegacyThemeServiceKey();

    return (
        <ThemeProvider colorScheme={themeKey}>
            <StyledBell variant={variant} alertState={alertState} />
        </ThemeProvider>
    );
};
